module.exports = __webpack_public_path__ + "static/media/icon-employer.fea5867a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-employer.svg
// module id = 548
// module chunks = 0